import React from 'react';
import PropTypes from 'prop-types';
import { ItemCards } from '../ItemCards';
import RenameContainerButton from '../RenameContainerButtonConnector';
import { formatPrice } from '../../../../helpers/formatNumbers';
import { ContainerActionsBar } from '../ContainerActionsBar';
import NewItemButton from '../NewItemButtonConnector';

const ContainerCard = ({
  containerId,
  label,
  name,
  retail,
  subtotal,
  isLockedOrOrdered,
  isMandi,
  isAutoReleaseDesign,
}) => {
  const RoomTotal = () => {
    if (isAutoReleaseDesign) {
      return <span className="price">{formatPrice(retail)}</span>;
    }
    const subTotalPrice = <span className="price containerSubtotalPrice">{formatPrice(subtotal)}</span>;
    if (retail > subtotal) {
      return [<span className="price containerRetailPrice">{formatPrice(retail)}</span>, subTotalPrice];
    }
    return subTotalPrice;
  };

  return (
    <div key={`container-${containerId}`} className="containerCard">
      <div className="containerInnerCard" id={`scrolltop-${containerId}`}>
        <div className="header">
          <span className="label">{label}</span>
          <span className="name truncateText" title={name}>{name}</span>
          <span className="rename">
            {!isLockedOrOrdered && !isMandi && (
              <RenameContainerButton containerId={containerId} />
            )}
          </span>
          <div className="containerTotals">
            <span className="containerTotalLabel">Room Total: </span>&nbsp;
            {RoomTotal()}
          </div>
          {!isLockedOrOrdered && !isMandi && (
            <ContainerActionsBar containerId={containerId} />
          )}
        </div>
        <ItemCards containerId={containerId} />
        <span id={`scrollbottom-${containerId}`} />
      </div>
      {!isLockedOrOrdered && !isMandi && (
        <NewItemButton containerId={containerId} />
      )}
    </div>);
};

ContainerCard.propTypes = {
  containerId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  retail: PropTypes.number.isRequired,
  subtotal: PropTypes.number.isRequired,
  isLockedOrOrdered: PropTypes.bool.isRequired,
  isMandi: PropTypes.bool,
  isAutoReleaseDesign: PropTypes.bool,
};

ContainerCard.defaultProps = {
  isMandi: false,
  isAutoReleaseDesign: false,
};

export default ContainerCard;
